import { Navigate } from "react-router-dom";
import { useAuth } from "../contextos/AuthProvider";

const ProtectedRoute =({children}) =>{
    const {user, loading}= useAuth();
    if(loading) return (<h1>Cargando sus datos de usuario...</h1>)
    if(!user )return(<Navigate to='/login' />)
    return <>{children}</>
}
export default ProtectedRoute